import React, { Component } from "react";
import Button from "components/UI/Button";
import Box from "components/UI/Box";
import axios from "axios";
import Pagination from "components/Pagination";
import Spinner from 'components/LoadingSpinner'
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { API_URL, ERROR_HANDLE } from "config/constants";
import theme from "../../../../Theme/theme";
import { submit } from '../../../../common/Utils'
import { Constants } from "../../../../common/constants";

const EDIT_TEXT = "Edit"
const DELETE_TEXT = "Delete"
const DELETE_ALERT_TEXT = "Are you sure you want to delete this gym tag";
const HEADER_TEXT = ["Tag Name", "Description", "Gym Count", "Actions"];
const CREATE_GYM_TAG_TEXT = "Create Gym Tag"

class GymTag extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gymTags: [],
            currentPage: 0,
            rowCount: Constants.DEFAULT_PAGINATION_COUNT,
            isLoading: true
        };
        this.toggledGymTagId = null;
    }

    componentDidMount() {
        this.getGymTags();
    }

    headerItems = HEADER_TEXT.map((label, i) => {
        return (
            <p style={style.titleItem} key={i}>
                {label}
            </p>
        );
    });

    header = () => <div style={style.titleWrapper}>{this.headerItems}</div>;

    getGymTags() {
        const access_token = localStorage.getItem("access_token");
        const toastId = toast("Fetching Gym Tags...");
        axios
            .get(`${API_URL}/tags`, {
                headers: {
                    "x-access-token": access_token
                }
            })
            .then(res => {
                toast.dismiss(toastId);
                this.setState({
                    ...this.state,
                    gymTags: res.data,
                    isLoading: false
                });
            })
            .catch(err => {
                toast.dismiss(toastId);
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    deleteGymTag(id) {
        const access_token = localStorage.getItem("access_token");
        const toastId = toast("Deleting Gym Tag...");
        axios
            .delete(`${API_URL}/tags/${id}`, {
                headers: {
                    "x-access-token": access_token
                }
            })
            .then(res => {
                toast.dismiss(toastId);
                this.removeGymTag(id)
            })
            .catch(err => {
                toast.dismiss(toastId);
                ERROR_HANDLE(err);
            });
    }

    removeGymTag(id) {
        const index = this.state.gymTags.findIndex(tag => tag.id === id);
        const gymTag = [...this.state.gymTags]; // make a separate copy of the array
        if (index !== -1) {
            gymTag.splice(index, 1);
            this.setState({
                gymTags: gymTag
            });
        }
    }

    renderGymTagDetail(currentItem) {
        return (
            <div style={style.valueWrapper}>
                <p style={style.valueItem}>{currentItem.name}</p>
                <p style={style.valueItem}>{currentItem.description}</p>
                <p style={style.valueItem}>{currentItem.gym_count}</p>
                <div style={{ display: "flex", flex: "1", justifyContent: "center", alignItems: "center" }}>
                    <Link to={{ pathname: "/gyms/GymTags/create/", state: { gymTagId: currentItem.id } }}>
                        <Button
                            type="holo"
                            holo
                            style={{ ...style.editButton }}
                        >
                            {EDIT_TEXT}
                        </Button>
                    </Link>
                    <Button
                        type="holo"
                        holo
                        style={{ ...style.deleteButton }}
                        onClick={() => {
                            submit(DELETE_ALERT_TEXT, () => {
                                this.deleteGymTag(currentItem.id);
                            })
                        }}
                    >
                        {DELETE_TEXT}
                    </Button>
                </div>
            </div >
        );
    }

    render() {
        const acl = localStorage.getItem("restricted_access");
        const rowCount = parseInt(this.state.rowCount)
        return (
            this.state.isLoading ? <Spinner loading={this.state.isLoading} /> : <div style={style.wrapper}>
                {acl === "false" ? <Link to="/gyms/GymTags/create/">
                    <Button
                        style={style.createGymTagButton}
                        type="primary"
                    >
                        {CREATE_GYM_TAG_TEXT}
                    </Button></Link> : null}
                {this.state.gymTags.length > 0 &&
                    <Box style={style.box} outline>
                        {this.header()}
                        {this.state.gymTags.map((currentItem, index) =>
                            index >= this.state.currentPage * rowCount &&
                            index < this.state.currentPage * rowCount + rowCount && this.renderGymTagDetail(currentItem)
                        )}
                    </Box>
                }
                {this.state.gymTags.length > 0 &&
                    <Pagination
                        currentPage={this.state.currentPage}
                        pageCount={this.state.gymTags.length / rowCount}
                        rowCount={rowCount}
                        pageAction={pageNumber => {
                            this.setState({ ...this.state, currentPage: pageNumber });
                        }}
                        updateRowCount={(rowCount) => this.setState({ rowCount, currentPage: 0 })}
                    />
                }
            </div >
        );
    }
}
export default GymTag;

const style = {
    titleWrapper: {
        display: "flex"
    },
    titleItem: {
        flex: "1",
        fontSize: "20px",
        color: theme.color.primaryBlue
    },
    box: {
        width: "900px"
    },
    wrapper: {
        display: "flex",
        justifyContent: "center",
        marginTop: "10px",
        flexDirection: "column",
        alignItems: "center"
    },
    valueWrapper: {
        display: "flex",
        borderTop: "1px solid " + theme.color.primaryBlue,
        borderRadius: "0.5px"
    },
    valueItem: {
        flex: "1",
        fontSize: "18px"
    },
    createGymTagButton: {
        width: "300px",
        fontSize: "20px",
        marginTop: "20px",
        marginBottom: "30px"
    },
    editButton: {
        width: "77px",
        height: "29px",
        fontSize: "16px",
        color: "#414141",
        marginRight: "5px",
        border: "solid 2px " + theme.color.primaryBlue
    },
    deleteButton: {
        width: "77px",
        height: "29px",
        fontSize: "16px",
        color: "#414141",
        marginLeft: "5px",
        border: "solid 2px " + theme.color.red
    }
};
